"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mainMenuReducer = exports.setDisabledButtons = exports.toggleMenuOpen = exports.selectMenuItem = exports.MainMenuStateActionType = exports.MenuButtonType = void 0;
const react_1 = require("react");
// import type { MenuButtonType } from '@completeanatomy/main-screen';
var MenuButtonType;
(function (MenuButtonType) {
    MenuButtonType["Hub"] = "hub";
    MenuButtonType["Search"] = "search";
    MenuButtonType["Tools"] = "tools";
    MenuButtonType["Library"] = "library";
    MenuButtonType["Store"] = "store";
    MenuButtonType["Settings"] = "settings";
    MenuButtonType["Tips"] = "tips-menu";
    MenuButtonType["ArMode"] = "ar-menu";
    MenuButtonType["SaveScreen"] = "save-screen";
    MenuButtonType["ExportImage"] = "export-image";
})(MenuButtonType || (exports.MenuButtonType = MenuButtonType = {}));
var MainMenuStateActionType;
(function (MainMenuStateActionType) {
    MainMenuStateActionType["Select"] = "selectMenuItem";
    MainMenuStateActionType["ToggleMenuOpen"] = "toggleMenuOpen";
    MainMenuStateActionType["SetDisabledButtons"] = "setDisabledButtons";
})(MainMenuStateActionType || (exports.MainMenuStateActionType = MainMenuStateActionType = {}));
const selectMenuItem = (state) => ({
    type: MainMenuStateActionType.Select,
    payload: state,
});
exports.selectMenuItem = selectMenuItem;
const toggleMenuOpen = (isOpen) => ({
    type: MainMenuStateActionType.ToggleMenuOpen,
    payload: isOpen,
});
exports.toggleMenuOpen = toggleMenuOpen;
const setDisabledButtons = (buttons) => ({
    type: MainMenuStateActionType.SetDisabledButtons,
    payload: buttons,
});
exports.setDisabledButtons = setDisabledButtons;
function mainMenuReducer(state, action) {
    switch (action.type) {
        case MainMenuStateActionType.Select:
            return Object.assign(Object.assign({}, state), { selectedItem: action.payload });
        case MainMenuStateActionType.ToggleMenuOpen:
            return Object.assign(Object.assign({}, state), { isMenuOpen: action.payload });
        case MainMenuStateActionType.SetDisabledButtons:
            return Object.assign(Object.assign({}, state), { disabledButtons: action.payload });
        default:
            return state;
    }
}
exports.mainMenuReducer = mainMenuReducer;
function useMainMenuReducer(state) {
    return (0, react_1.useReducer)(mainMenuReducer, state);
}
exports.default = useMainMenuReducer;
